export default __webpack_public_path__ + "static/media/Map_Aspen.ee09deac.jpg";